import React, { useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { TextArea, Button, TextTag as Text } from "../../atoms"
import { PageHeader } from "../../molecules/PageHeader"
import { ArrowLeftOutlined } from "@ant-design/icons"
import _ from "../../utils/lodashUtils"

import {
  HELP_HEADING,
  HELP_LABEL,
  HELP_SUCCESS,
  SUBMIT_BUTTON,
  BACK_BUTTON,
  placeHolder_Help,
} from "../../constants/messages"
import { getHelp } from "../../redux/actionCreators/auth"
import history from "../../history"
import "./HelpPage.scss"
import { setSubmitting } from "../../redux/actionCreators/planDinnner"
import { ActivityIndicator } from "../../components/ActivityIndicator"

const HelpPage = ({ getHelp, submittingForm, setSubmitting }) => {
  const [feedback, setFeedback] = useState("")
  const [successMessage, setSuccessMessage] = useState(false)

  const goBackHandle = () => {
    history.push("/dashboard")
  }

  const submitFeedBack = async () => {
    setSubmitting(true)
    try {
      await getHelp(feedback).then((succeess) => {
        setFeedback("")
        setSuccessMessage(true)
      })
      setSubmitting(false)
    } catch {
      setSubmitting(false)
    }
  }
  return (
    <div id="helpPage">
      <div id="container">
        <PageHeader
          onClick={goBackHandle}
          icon={<ArrowLeftOutlined />}
          btnText={BACK_BUTTON}
          headerText={HELP_LABEL}
        />
        <div className="spacing-btwn">
          <Text textType="bodyHeading">{HELP_HEADING}</Text>
        </div>
        {successMessage && !feedback ? (
          <div className="spacing-btwn">
            <Text textType="default">{HELP_SUCCESS}</Text>
          </div>
        ) : null}
        <div className="spacing-btwn text-area">
          <TextArea
            placeholder={placeHolder_Help}
            autoSize={{ minRows: 6, maxRows: 12 }}
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
          />
        </div>
        <div className="submit-btn">
          <Button
            btnType="primary"
            btnSize="large"
            onClick={submitFeedBack}
            disabled={!feedback || submittingForm}
          >
            {submittingForm && <ActivityIndicator />}
            {SUBMIT_BUTTON}
          </Button>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
  partners: state.invitePeople.partnerDetails,
  partner: state.auth.partner,
  submittingForm: state.loadingState.submittingForm,
})

export default connect(mapStateToProps, { getHelp, setSubmitting })(
  withRouter(HelpPage)
)
